import { Text } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';


const EmailCheckerPage = () => {
  return (
    <Text>
      <FormattedMessage
        id="SoonPageText"
        values={{
          br: (
              <br />
          ),
          hereLink: (
            <Link to="/tools/ip-check" className="soon-page-link">
              <FormattedMessage id="SoonPageLinkText" />
            </Link>
          ),
        }}
      />
    </Text>
  );
};

export default EmailCheckerPage;
